import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export type EnrichmentStatus = 'pending' | 'processing' | 'completed' | 'failed' | null;

interface Props {
  status: EnrichmentStatus;
}

export function EnrichmentStatusBadge({ status }: Props) {
  if (!status) return null;

  switch (status) {
    case 'pending':
      return (
        <Badge variant="outline" className="bg-gray-50 text-gray-600 border-gray-200">
          <Clock className="w-3 h-3 mr-1" />
          Pending
        </Badge>
      );
    case 'processing':
      return (
        <Badge variant="secondary" className="bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-50">
          <LoadingSpinner size="small" label="Processing" />
        </Badge>
      );
    case 'completed':
      return (
        <Badge variant="default" className="bg-green-50 text-green-700 border-green-200 hover:bg-green-50">
          <CheckCircle2 className="w-3 h-3 mr-1" />
          Completed
        </Badge>
      );
    case 'failed':
      return (
        <Badge variant="destructive" className="bg-red-50 text-red-700 border-red-200 hover:bg-red-50">
          <XCircle className="w-3 h-3 mr-1" />
          Failed
        </Badge>
      );
    default:
      return null;
  }
}
